<template>
  <v-data-table
    :items="getMappedDeliverySlips"
    :loading="loading"
    :headers="getHeaders"
    :search="search"
    sort-by="created"
    :mobile-breakpoint="0"
    :sort-desc="true"
    :hide-default-header="$vuetify.breakpoint.xsOnly"
    hide-default-footer
    :items-per-page="$vuetify.breakpoint.xsOnly ? 8 : 10"
    @page-count="pageCount = $event"
    :page.sync="page"
  >
    <template v-slot:item.created="{ item }">
      {{ item.createdDisplay }}
    </template>
    <template v-slot:item.is_receive="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon
            v-on="on"
            v-if="item.is_receive === true && item.is_closed === false"
            color="warning"
            >far fa-check-circle</v-icon
          >
        </template>
        Commande reçu mais en attente d'être fermé
      </v-tooltip>
    </template>
    <template v-slot:item.mobile="{ item }">
      <div class="my-1">
        <v-row align="center" justify="start" no-gutters>
          <v-icon x-small left>fa-calendar</v-icon>
          <span>{{ item.created }}</span>
        </v-row>
        <v-row align="center" justify="start" no-gutters class="mt-1">
          <v-icon x-small left>fa-user</v-icon>
          <span>{{ item.author }}</span>
        </v-row>
        <v-row
          align="center"
          justify="start"
          no-gutters
          v-if="item.supplier"
          class="mt-1"
        >
          <v-icon x-small left>fa-building</v-icon>
          <span>{{ item.supplierName }}</span>
        </v-row>
      </div>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-row align="center" justify="end" no-gutters>
        <v-btn
          icon
          :large="$vuetify.breakpoint.xsOnly"
          :to="{ name: 'DeliverySlipViewer', params: { id: item.id } }"
        >
          <v-icon :large="$vuetify.breakpoint.xsOnly"
            >fa-external-link-alt</v-icon
          >
        </v-btn>
      </v-row>
    </template>
    <template v-slot:top>
      <v-row align="center" justify="end" dense>
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            filled
            hide-details
            single-line
            clearable
            prepend-inner-icon="fa-search"
            v-model="search"
            class="no-before"
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
    <template v-slot:footer>
      <v-pagination
        color="accent"
        v-model="page"
        :length="pageCount"
        :total-visible="5"
      ></v-pagination>
    </template>
  </v-data-table>
</template>

<script>
import { api } from "@/api";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "DeliverySlipGrid",
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    history: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getIsAdmin", "getDeliverySlips", "getSuppliers"]),
    getMappedDeliverySlips() {
      return this.getDeliverySlips
        .filter(x => (this.history ? true : x.is_closed === false))
        .map(x => {
          const supplier = this.getSuppliers.find(
            s => s.id_fournisseur == x.fk_supplier
          );
          return {
            ...x,
            supplierName: supplier ? supplier.name_fournisseur : "",
            createdDisplay: moment(x.created).format("LLL")
          };
        });
    },
    getHeaders() {
      if (this.getIsAdmin) {
        if (this.$vuetify.breakpoint.xsOnly) {
          return [
            { value: "is_receive", text: "", sortable: false },
            { value: "mobile", text: "" },
            { value: "actions", text: "", sortable: false }
          ];
        } else {
          return [
            { value: "is_receive", text: "", sortable: false },
            { value: "created", text: "Créé le" },
            { value: "author", text: "Par" },
            { value: "supplierName", text: "Fournisseur" },
            { value: "actions", text: "", sortable: false }
          ];
        }
      } else {
        if (this.$vuetify.breakpoint.xsOnly) {
          return [
            { value: "is_receive", text: "", sortable: false },
            { value: "mobile", text: "" },
            { value: "actions", text: "", sortable: false }
          ];
        } else {
          return [
            { value: "is_receive", text: "", sortable: false },
            { value: "created", text: "Créé le" },
            { value: "author", text: "Par" },
            { value: "supplierName", text: "Fournisseur" },
            { value: "actions", text: "", sortable: false }
          ];
        }
      }
    }
  },
  data() {
    return {
      search: "",
      page: 1,
      pageCount: 0
    };
  },
  methods: {
    async closeDeliverySlip(item) {
      try {
        this.$store.dispatch("slo");
        const data = {
          ...item,
          is_receive: true
        };
        const tasks = [];
        item.delivery_slip_products.forEach(x => {
          const d = {
            ...x,
            quantity_received: x.quantity_ordered
          };
          tasks.push(api.patchDeliverySlipProduct(x.id, d));
          const r = {
            fk_product: x.fk_product,
            store: x.store,
            date: moment(new Date(Date.now())).format(
              "YYYY-MM-DDTHH:mm:ss.SSSSSSZ"
            ),
            quantity: x.quantity_ordered
          };
          tasks.push(api.postInventoryTransaction(r));
        });
        tasks.push(api.patchDeliverySlip(item.id, data));
        await Promise.all(tasks);
        await this.$store.dispatch("loadDeliverySlips");
      } finally {
        this.$store.dispatch("elo");
      }
    }
  }
};
</script>

<style></style>
